var map = {
	"./MSMT.svg": 291,
	"./academy-white.svg": 248,
	"./academy.svg": 749,
	"./certificate-stamp.svg": 258,
	"./eshop.svg": 750,
	"./fitness.svg": 751,
	"./gym.svg": 752,
	"./logo-mediaform.svg": 409,
	"./partners/logo-escape.svg": 753,
	"./partners/logo-hammer-strength.svg": 754,
	"./partners/logo-lifefitness.svg": 755,
	"./partners/logo-spirit.svg": 756,
	"./partners/logo-total-gym.svg": 757,
	"./partners/logo-trx.svg": 758,
	"./satna.svg": 759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 408;